<template>
  <generic-modal
    size="large"
    :title="$t('query builder')"
    icon="database"
    image="/images/icons/database_query.png"
    v-bind:scrolling="true"
    v-on:destroy="this.destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <h4 class="ui dividing header">{{ $t("select datasource and build your query") }}</h4>
      <div class="ui form" id="rqb"></div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
// require("@/assets/RedQueryBuilder/RedQueryBuilder.nocache.js");
// require("@/assets/RedQueryBuilder/RedQueryBuilderFactory.nocache.js");
// require("../../../../assets/RedQueryBuilder/RedQueryBuilder.nocache");
import "@/assets/RedQueryBuilder/gwt/dark/dark.css";
import { rqb } from "./red_query_builder";

export default {
  name: "QueryBuilderModal",
  components: {
    "generic-modal": GenericModal
  },
  props: {
    input_query: Object,
    datasources: Array
  },
  computed: {},
  data() {
    return {
      sql: "",
      args: []
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          vm.$emit("succedded", {
            sql: vm.sql,
            args: vm.args,
            query: vm.input_query
          });
          resolve();
        }
      });
    },
    destroy() {
      this.$emit("destroy");
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        reason: ["empty"]
      }
    });

    if (vm.input_query) {
      if (vm.input_query.datasource) {
        let _ds = vm.datasources.find(d => d.uuid == vm.input_query.datasource);
        if (_ds) {
          let sql = vm.input_query.query || "";
          let args = vm.input_query.args || [];
          let columns = _ds.setup.fields.map(elmnt => {
            let _type = "STRING";
            if (elmnt.type == "int") _type = "INTEGER";
            else if (elmnt.type == "double") _type = "DECIMAL";
            else if (elmnt.type == "date") _type = "DATE";
            return {
              name: elmnt.name,
              type: _type,
              label: elmnt.name
              // size: elmnt.size
            };
          });

          let sqlChange = function(_sql, _args) {
            vm.sql = _sql;
            vm.args = _args;
            sql = _sql;
            args = _args;

            window
              .jQuery("#rqb")
              .find("select")
              .css("width", "auto");
          };

          setTimeout(() => {
            rqb(_ds.table_name, _ds.name, columns, sql, args, sqlChange);
          }, 200);
        }
      } else console.error("no datasource selected");
    } else console.error("no input query selected");
  },
  created() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "/assets/RedQueryBuilder/RedQueryBuilder.nocache.js"
    );
    document.head.appendChild(recaptchaScript);
    recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "/assets/RedQueryBuilder/RedQueryBuilderFactory.nocache.js"
    );
    document.head.appendChild(recaptchaScript);
  },
  watch: {},
  updated: function() {}
};
</script>
